import React from 'react';

// Design law: player/team names are ALWAYS neutral white — identity comes from
// accent bars and avatar tints, never colored text. Losers dim, never strikethrough.
export default function TeamName({ name, dim = false, bold = false, size = null }) {
  // Default is responsive (12.5px on phones, 13.5px from sm:) so 375px screens
  // fit typical Filipino names before the ellipsis kicks in.
  return (
    <span className={`min-w-0 truncate ${size == null ? 'text-[12.5px] sm:text-[13.5px]' : ''}`} title={name}
      style={{ color: '#FFFFFF', opacity: dim ? 0.55 : 1, fontWeight: bold ? 700 : 600,
        ...(size != null ? { fontSize: size } : {}) }}>
      {name || 'TBD'}
    </span>
  );
}
